import React, { FC } from 'react';
import { BlockType } from '../../../../../config/api/models/Block';
import AddBlockButtonLarge from './AddBlockButtonLarge';
import { AddBlockButtonProps } from '../../../types';
import AddBlockButton from './AddBlockButton';
import { useAppDispatch, useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';
import { createSection } from 'src/modules/shared/slices/blocks/api/blocks';
import { SpriteIconsLight } from 'src/config/api/models/FontAwesome';

const AddSectionBlockButton: FC<AddBlockButtonProps> = ({
  viewMode,
  previousBlockId,
  clusterId,
}) => {
  const dispatch = useAppDispatch();

  const currentPageId = useAppSelector((state) => state.trajectories.currentPageId);

  const handleClick = () => {
    if (!currentPageId) return;
    let beforeBlockId = previousBlockId ?? '';

    if (clusterId) {
      return dispatch(createSection({ beforeBlockId, clusterId: clusterId }));
    }
  };

  return (
    <>
      {
        {
          emptyPage: (
            <AddBlockButtonLarge
              title={'Sectie'}
              description={'Nieuwe sectie starten'}
              FAicon={SpriteIconsLight.ARROWS_FROM_LINE}
              onClick={handleClick}
            />
          ),
          sidebar: (
            <AddBlockButton
              tooltip="Nieuwe sectie starten"
              type={BlockType.SECTION}
              FAicon={SpriteIconsLight.ARROWS_FROM_LINE}
              onClick={handleClick}
            />
          ),
        }[viewMode]
      }
    </>
  );
};

export default AddSectionBlockButton;
